import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ManageAddressesEdit } from '@components/templates/myAccount';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { useParams } from 'react-router';
import { useGetMyAccountAddressesDetail } from '@services/useGetMyAccountAddressesDetail';

export function ManageAddressesEditPage() {
    const { t } = useTranslation();
    const { request: requestGetMyAccountAddressesDetail } = useGetMyAccountAddressesDetail();
    const { uuid } = useParams();

    const translations = {
        title: t('manage-addresses-component.metatags.title'),
        description: t('manage-addresses-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.myAddressesEdit.replace(':uuid', `${uuid}`),
        index: false,
    });

    // Fetch address data based on UUID
    useEffect(() => {
        if (uuid) {
            requestGetMyAccountAddressesDetail({ uuid });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uuid]);

    return <ManageAddressesEdit />;
}
